<template>
  <CRow>
    <CCol sm="12">
      <CCard class="mt-4">
        <CCardHeader>
          <CIcon name="cil-description" class="mr-3"/>
          <h5>Protokoll</h5>
        </CCardHeader>
        <CCardBody>
          <CForm @submit.prevent="">
            <CRow class="mt-3">
              <CCol sm="5">
                <Firma v-model="kunde"/>
              </CCol>
              <CCol sm="3">
                <Datum v-model="datum"/>
                <Abgeschlossen v-model="abgeschlossen"/>
              </CCol>
              <CCol sm="4">
                <Leistung v-model="leistung"/>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <Projekt v-model="projekt" :kunde="kunde"/>
              </CCol>
            </CRow>

            <CRow class="mt-3">
              <CCol sm="12">
                <Arbeitsbeschreibung v-model="arbeitsbeschreibung"/>
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12">
                <Material :key="materialFormKey" v-model="material" :material-vorgabe="materialVorgabe"/>
              </CCol>
            </CRow>

            <CRow class="mt-3">
              <CCol sm="12">
                <Arbeitszeit :key="arbeitszeitFormKey" v-model="arbeitszeit" :zukuenftig-berechnen="zukuenftigBerechnen"/>
              </CCol>
            </CRow>

            <CRow class="mt-3">
              <CCol sm="12">
                <Tageskalender v-model="tageskalender" />
              </CCol>
            </CRow>

            <CRow class="mt-3">
              <CCol sm="12">
                <SaveRetentionOptions
                  v-model="keepAfterSave"
                  :options="keepAfterSaveOptions"
                  :persist-value.sync="persistKeepAfterSave"
                />
              </CCol>
            </CRow>

            <CRow class="mt-3">
              <CCol sm="12">
                <CSpinner color="" v-show="isSubmitting()"></CSpinner>
                <span class="fs-6" v-show="isSubmitting() &! successModal">wird gespeichert...</span>
                <CButton
                  v-on:click="newEntry()"
                  :color="btnColor()"
                  class="btn-protokoll-submit btn-block font-weight-bold pt-3 pb-3"
                >
                  <CIcon name="cil-library-add"/>
                  &nbsp;
                  Protokoll speichern
                </CButton>

              </CCol>
            </CRow>
            <CModal
              title='Protokoll erfolgreich angelegt'
              color="success"
              size="sm"
              :show="successModal"
            >
              Das Protokoll wurde gespeichert! Wollen sie das Protokoll unterschreiben oder drucken?
              <br/>
              <br/>
              <div class="d-none alert alert-warning">
                Die Protokolle werden automatisch jeden Tag um 23:00 Uhr als PDF gespeichert. <br/>
                Die Protokolle werden erneut gespeichert, wenn diese aktualisiert wurden und z.B die Unterschrift nachgereicht wird.
              </div>
              <template #footer>
                <div style="float: left">
                  <CButton  color="default" @click="closeSite" class="mr-2">Schließen</CButton>
                </div>
                <div>
                  <CButton @click="print" color="info" class="mr-2">Unterschreiben oder Drucken</CButton>
                </div>
              </template>
            </CModal>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Firma from './components/Firma'
import Datum from './components/Datum'
import Abgeschlossen from './components/Abgeschlossen'
import Leistung from '@/components/LeistungsAuswahl'
import Projekt from './components/Projekt'
import Arbeitsbeschreibung from './components/Arbeitsbeschreibung'
import Material from './components/Material'
import Arbeitszeit from './components/Arbeitszeit'
import Tageskalender from './components/Tageskalender'
import SaveRetentionOptions from '@/components/SaveRetentionOptions'
import Vue from 'vue'
import moment from 'moment/moment'

const KEEP_AFTER_SAVE_STORAGE_KEY = 'protokoll-keep-after-save'
const KEEP_AFTER_SAVE_PERSISTENCE_KEY = 'protokoll-keep-after-save-persist'

const createKeepAfterSaveDefaults = () => ({
  kunde: true,
  projekt: true,
  abgeschlossen: false,
  leistung: false,
  arbeitsbeschreibung: false,
  material: false,
  arbeitszeiten: false,
  tageskalender: false
})

const createMaterialVorgabeDefaults = () => ([
  {
    id: 1,
    stueckzahl: '1',
    artikelnr: '-',
    material: 'Klein-/Verdrahtungs-/u. Befestigungsmaterial'
  },
  {
    id: 2,
    stueckzahl: '1',
    artikelnr: '-',
    material: 'Anteilige Fahrzeugpauschale'
  }
])

export default {
  name: 'MitarbeiterEdit',
  components: {
    Firma,
    Datum,
    Abgeschlossen,
    Leistung,
    Projekt,
    Arbeitsbeschreibung,
    Material,
    Arbeitszeit,
    Tageskalender,
    SaveRetentionOptions
  },
  created () {
  },
  data () {
    return {
      submitting: false,
      kunde: '',
      datum: null,
      abgeschlossen: true,
      leistung: null,
      projekt: null,
      arbeitsbeschreibung: '',
      material: [],
      arbeitszeit: [],
      materialFormKey: 0,
      arbeitszeitFormKey: 0,
      successModal: false,
      successData: {},
      tageskalender: true,
      materialVorgabe: [],
      materialVorgabeDefault: createMaterialVorgabeDefaults(),
      zukuenftigBerechnen: [],
      keepAfterSave: createKeepAfterSaveDefaults(),
      persistKeepAfterSave: false
    }
  },
  computed: {
    keepAfterSaveOptions () {
      return [
        { key: 'kunde', label: 'Kunde' },
        { key: 'projekt', label: 'Projekt' },
        { key: 'abgeschlossen', label: 'Abgeschlossen' },
        { key: 'leistung', label: 'Leistung' },
        { key: 'arbeitsbeschreibung', label: 'Arbeitsbeschreibung' },
        { key: 'material', label: 'Material' },
        { key: 'arbeitszeiten', label: 'Arbeitszeiten' },
        { key: 'tageskalender', label: 'Tageskalender' }
      ]
    }
  },
  mounted () {
    this.loadKeepAfterSaveOptions()
    this.setDefaults()
  },
  watch: {
    kunde: function () {
      this.projekt = null
      this.loadArbeitszeitenAuto()
    },
    projekt: function () {
      this.loadArbeitszeitenAuto()
    },
    material: function () {
    },
    keepAfterSave: {
      deep: true,
      handler: function () {
        if (this.persistKeepAfterSave) {
          localStorage.setItem(KEEP_AFTER_SAVE_STORAGE_KEY, JSON.stringify(this.keepAfterSave))
        }
      }
    },
    persistKeepAfterSave: function () {
      if (this.persistKeepAfterSave) {
        localStorage.setItem(KEEP_AFTER_SAVE_PERSISTENCE_KEY, 'true')
        localStorage.setItem(KEEP_AFTER_SAVE_STORAGE_KEY, JSON.stringify(this.keepAfterSave))
      } else {
        localStorage.removeItem(KEEP_AFTER_SAVE_PERSISTENCE_KEY)
        localStorage.removeItem(KEEP_AFTER_SAVE_STORAGE_KEY)
        this.keepAfterSave = createKeepAfterSaveDefaults()
      }
    }
  },
  methods: {
    createMaterialVorgabeDefaultEntries () {
      return createMaterialVorgabeDefaults()
    },
    loadKeepAfterSaveOptions () {
      const defaults = createKeepAfterSaveDefaults()
      this.persistKeepAfterSave = localStorage.getItem(KEEP_AFTER_SAVE_PERSISTENCE_KEY) === 'true'

      if (!this.persistKeepAfterSave) {
        this.keepAfterSave = defaults
        return
      }

      const rawValue = localStorage.getItem(KEEP_AFTER_SAVE_STORAGE_KEY)

      if (!rawValue) {
        this.keepAfterSave = defaults
        return
      }

      try {
        this.keepAfterSave = {
          ...defaults,
          ...JSON.parse(rawValue)
        }
      } catch (error) {
        this.keepAfterSave = defaults
      }
    },
    bumpMaterialFormKey () {
      this.materialFormKey += 1
    },
    bumpArbeitszeitFormKey () {
      this.arbeitszeitFormKey += 1
    },
    cloneValue (value) {
      return {
        ...value
      }
    },
    isMaterialSavable (material) {
      if (!material || !('stueckzahl' in material)) {
        return false
      }

      return String(material.stueckzahl).trim() !== ''
    },
    getSavableMaterialEntries () {
      return this.material.filter((material) => this.isMaterialSavable(material))
    },
    isArbeitszeitSavable (arbeitszeit) {
      if (!arbeitszeit) {
        return false
      }

      return 'datum' in arbeitszeit &&
        arbeitszeit.datum !== '' &&
        'dauer' in arbeitszeit &&
        arbeitszeit.dauer > 0 &&
        'mitarbeiter' in arbeitszeit &&
        arbeitszeit.mitarbeiter > 0
    },
    getSavableArbeitszeiten () {
      return this.arbeitszeit.filter((arbeitszeit) => this.isArbeitszeitSavable(arbeitszeit))
    },
    getManualArbeitszeiten () {
      return this.arbeitszeit
        .filter((eintrag) => !eintrag.auto)
        .map((eintrag) => this.cloneValue(eintrag))
    },
    setDefaults () {
      this.kunde = ''
      this.datum = new Date()
      this.abgeschlossen = true
      this.leistung = null
      this.projekt = null
      this.arbeitsbeschreibung = ''
      this.material = []
      this.submitGoing = false
      this.arbeitszeit = []
      this.tageskalender = true
      this.materialVorgabe = this.createMaterialVorgabeDefaultEntries()
      this.zukuenftigBerechnen = []
      this.bumpMaterialFormKey()
      this.bumpArbeitszeitFormKey()
    },
    resetAfterSave () {
      const manualArbeitszeiten = this.keepAfterSave.arbeitszeiten ? this.getManualArbeitszeiten() : []

      this.submitGoing = false
      this.datum = new Date()

      if (!this.keepAfterSave.kunde) {
        this.kunde = ''
      }

      if (!this.keepAfterSave.kunde || !this.keepAfterSave.projekt) {
        this.projekt = null
      }

      if (!this.keepAfterSave.abgeschlossen) {
        this.abgeschlossen = true
      }

      if (!this.keepAfterSave.leistung) {
        this.leistung = null
      }

      if (!this.keepAfterSave.arbeitsbeschreibung) {
        this.arbeitsbeschreibung = ''
      }

      if (!this.keepAfterSave.material) {
        this.material = []
        this.materialVorgabe = this.createMaterialVorgabeDefaultEntries()
        this.bumpMaterialFormKey()
      }

      if (this.keepAfterSave.arbeitszeiten) {
        this.arbeitszeit = manualArbeitszeiten
        this.zukuenftigBerechnen = []
      } else {
        this.arbeitszeit = []
        this.zukuenftigBerechnen = []
        this.bumpArbeitszeitFormKey()
      }

      if (!this.keepAfterSave.tageskalender) {
        this.tageskalender = true
      }

      if (this.kunde && this.keepAfterSave.kunde) {
        this.loadArbeitszeitenAuto()
      }
    },
    isSubmitting: function () {
      return this.submitting
    },
    canSubmit: function () {
      let disabled = false
      const savableArbeitszeiten = this.getSavableArbeitszeiten()
      const savableMaterialEntries = this.getSavableMaterialEntries()

      if (this.submitGoing) {
        disabled = true
      }

      if (!this.kunde) {
        disabled = true
      }

      if (savableArbeitszeiten.length === 0) {
        disabled = true
      }

      if (!this.leistung) {
        disabled = true
      }
      if (this.arbeitsbeschreibung.length === 0) {
        disabled = true
      }
      if (savableMaterialEntries.length === 0 && this.materialVorgabe.length === 0) {
        disabled = true
      }
      if (savableArbeitszeiten.length === 0) {
        disabled = true
      }
      return disabled
    },
    btnColor: function () {
      if (!this.canSubmit()) {
        return 'success'
      } else {
        return 'success'
      }
    },
    newEntry: function () {
      const self = this
      const savableArbeitszeiten = this.getSavableArbeitszeiten()
      const savableMaterialEntries = this.getSavableMaterialEntries()

      if (!this.submitGoing && this.arbeitsbeschreibung && savableArbeitszeiten.length > 0 && this.datum && this.kunde.kundenid && this.leistung) {
        this.submitGoing = true
        // An diesem Punkt sollte das Formular validiert und fertig sein
        this.submitting = true

        Vue.axios.post('/protokoll/post', {
          datum: this.dateFormatter(this.datum),
          arbeitsbeschreibung: this.arbeitsbeschreibung,
          tageskalender: this.tageskalender,
          abgeschlossen: this.abgeschlossen,
          kunde: this.kunde.kundenid,
          projekt: this.projekt,
          leistung: this.leistung
        }).then((response) => {
          if (response.data.protokollid) {
            const promisesForAsync = []

            const protokollid = response.data.protokollid
            // Alle Materialien speichern
            this._.forEach(this.materialVorgabe, function (m) {
              const normalizedMaterial = self.normalizeMaterialPayload(m)
              Vue.axios.post('/material/post', {
                protokoll: protokollid,
                stueck: normalizedMaterial.stueckzahl,
                artikelnr: normalizedMaterial.artikelnr,
                material: normalizedMaterial.material
              })
            })
            this._.forEach(savableMaterialEntries, function (m) {
              const normalizedMaterial = self.normalizeMaterialPayload(m)
              promisesForAsync.push(Vue.axios.post('/material/post', {
                protokoll: protokollid,
                stueck: normalizedMaterial.stueckzahl,
                artikelnr: normalizedMaterial.artikelnr,
                material: normalizedMaterial.material
              }))
            })
            // Alle Arbeitszeiten speichern
            this._.forEach(savableArbeitszeiten, (a) => {
              let taetigkeit = a.taetigkeit
              if (!taetigkeit) {
                taetigkeit = ''
              }
              const arbeitszeitPromise = Vue.axios.post('/arbeitszeit/post', {
                protokoll: protokollid,
                auto: a.auto || false,
                mitarbeiter: a.mitarbeiter,
                datum: this.dateFormatter(a.datum),
                dauer: a.dauer,
                taetigkeit: taetigkeit
              }).then((response) => {
                // Bei automatischen Einträgen die Bilder übertragen und den Tageskalender-Eintrag löschen
                if (a.auto) {
                  const arbeitszeitid = response.data.arbeitszeitid
                  const tageskalenderid = a.tageskalenderid
                  promisesForAsync.push(Vue.axios.delete('/tageskalender/deleteauto/' + arbeitszeitid + '/' + tageskalenderid))
                }
                // Bei neuen Einträgen ggf. die Bilder speichern
                if (!a.auto) {
                  self.saveImage(response.data.arbeitszeitid, 'bild01', a.image01)
                  self.saveImage(response.data.arbeitszeitid, 'bild02', a.image02)
                  self.saveImage(response.data.arbeitszeitid, 'bild03', a.image03)
                  self.saveImage(response.data.arbeitszeitid, 'bild04', a.image04)
                  self.saveImage(response.data.arbeitszeitid, 'bild05', a.image05)
                }

                Promise.all(promisesForAsync).then(values => {
                  this.resetAfterSave()
                  this.$snotify.success('Protokoll wird gespeichert.', {
                    position: 'rightTop',
                    timeout: 4000
                  })
                  const routeData = self.$router.resolve({ path: `/print/${protokollid}` })
                  // window.open(routeData.href, '_blank')
                  // location.reload()
                  this.successData = {
                    link: routeData.href
                  }
                  this.successModal = true
                  this.submitting = false
                  this.submitGoing = false
                })
              })
              promisesForAsync.push(arbeitszeitPromise)
            })
          } else {
            this.$snotify.error('Unbestimmter Fehler beim Speichern eines Protokolls.', {
              position: 'rightTop',
              timeout: 4000
            })
            this.submitGoing = false
            this.submitting = false
          }
        }).catch((error) => {
          console.log('error.response.data')
          this.formError = error.response.data
          this.submitGoing = false
          this.submitting = false
        })
      } else {
        let error = ''

        if (!this.arbeitsbeschreibung) {
          error = 'Arbeitsbeschreibung'
        }

        if (savableArbeitszeiten.length === 0) {
          error = 'Arbeitszeit'
        }

        if (!this.datum) {
          error = 'Datum'
        }
        if (!this.kunde.kundenid) {
          error = 'Kunde'
        }
        if (!this.leistung) {
          error = 'Leistung'
        }

        this.$snotify.error('Bitte fülle alle Pflichtfelder aus um das Protokoll zu speichern. (' + error + ')', {
          position: 'rightTop',
          timeout: 4000
        })
      }
    },
    closeSite () {
      this.successModal = false
      this.submitGoing = false
    },
    print () {
      this.successModal = false
      window.open(this.successData.link, '_blank')
    },
    dateFormatter (value) {
      if (moment(value, 'DD.MM.YYYY', true).isValid()) {
        value = moment(value, 'DD.MM.YYYY', true).format('DD.MM.YYYY')
      }
      return value
    },
    normalizeMaterialPayload (material) {
      return {
        ...material,
        stueckzahl: typeof material.stueckzahl === 'string' ? material.stueckzahl.trim() : material.stueckzahl,
        artikelnr: typeof material.artikelnr === 'string' ? material.artikelnr.trim() : material.artikelnr,
        material: typeof material.material === 'string' ? material.material.trim() : material.material
      }
    },
    loadArbeitszeitenAuto () {
      if (!this.kunde || this.kunde === '') {
        this.zukuenftigBerechnen = []
        return
      }

      const result = []
      const self = this

      Vue.axios.post('/tageskalender/zukuenftigberechnen', {
        kundenid: this.kunde.kundenid,
        projektid: this.projekt
      }).then((response) => {
        if (response.data && response.data.length > 0) {
          self._.forEach(response.data, function (tk) {
            result.push({
              auto: true,
              tageskalenderid: tk.tageskalenderid,
              datum: self.dateFormatter(tk.datum),
              dauer: parseFloat(tk.dauer),
              mitarbeiter: tk.mitarbeiter.mitarbeiterid,
              taetigkeit: tk.taetigkeit,
              bilder: tk.bilder
            })
          })
        }

        this.zukuenftigBerechnen = result
      })
    },
    saveImage (arbeitszeitid, selektor, image) {
      if (image) {
        const formData = new FormData()
        formData.append('selektor', selektor)
        formData.append('dbid', arbeitszeitid)
        formData.append('target', 'arbeitszeit')
        formData.append('uploadfile', image)

        Vue.axios.post(
          '/bilder/upload',
          formData,
          {
            headers: {
              'content-type': `multipart/form-data; boundary=${formData._boundary}`
            }
          }
        )
      }
    }
  }
}

</script>

<style lang="scss">
button.btn-protokoll-submit:disabled {
  cursor: default;
}
</style>
